import {
  CREATE_SETTINGS_NEW_RECORD,
  CREATE_SETTINGS_NEW_RECORD_SUCCESS,
  CREATE_SETTINGS_NEW_RECORD_ERROR,  
  
  GET_SETTINGS_NEW_RECORD,
  GET_SETTINGS_NEW_RECORD_SUCCESS,
  GET_SETTINGS_NEW_RECORD_ERROR,  

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";

export const getSettingNewRecord = (settingid, history) => ({
    type: GET_SETTINGS_NEW_RECORD,
    payload: {settingid, history}
  });

export const getSettingNewRecordSuccess = (recordCreated) => ({
  type: GET_SETTINGS_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getSettingNewRecordError = (message) => ({
  type: GET_SETTINGS_NEW_RECORD_ERROR,
  payload: { message },
});

export const createSettingNewRecord = (newRecord, history) => ({
    type: CREATE_SETTINGS_NEW_RECORD,
    payload: {newRecord, history}
  });

export const createSettingNewRecordSuccess = (recordCreated) => ({
  type: CREATE_SETTINGS_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createSettingNewRecordError = (message) => ({
  type: CREATE_SETTINGS_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});